
@if (isOpen() && activeCustomer(); as cust) {
  <div (click)="onBackdropClick($event)" class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 animate-fade-in-fast">
    <div class="bg-white rounded-lg shadow-xl w-full max-w-5xl p-6 text-slate-800 m-4 flex flex-col max-h-[95vh]">
      
      @if(view() === 'success') {
        <div class="flex flex-col items-center justify-center py-10 text-center animate-bounce-in">
            <div class="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mb-6">
                <i class="fa-solid fa-check text-5xl text-green-600"></i>
            </div>
            <h2 class="text-3xl font-bold text-gray-800 mb-2">อนุมัติเรียบร้อยแล้ว</h2>
            <p class="text-gray-500 mb-8">Prescription Approved Successfully</p>
            
            <div class="flex flex-col sm:flex-row gap-4 w-full max-w-md">
                <button (click)="printPrescription()" class="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 px-6 rounded-xl shadow-lg transition-transform transform hover:scale-105 flex items-center justify-center gap-3">
                    <i class="fa-solid fa-print text-xl"></i> 
                    <span>พิมพ์ใบรับรองแพทย์<br><span class="text-xs font-normal opacity-80">Print Certificate</span></span>
                </button>
                <button (click)="onClose()" class="flex-1 bg-slate-200 hover:bg-slate-300 text-slate-700 font-bold py-4 px-6 rounded-xl transition-colors flex items-center justify-center gap-3">
                    <i class="fa-solid fa-times text-xl"></i>
                    <span>ปิดหน้าต่าง<br><span class="text-xs font-normal opacity-70">Close</span></span>
                </button>
            </div>
        </div>
      } 
      
      @else {
        <!-- HEADER -->
        <div class="flex-shrink-0 flex justify-between items-center mb-4 border-b pb-4">
            <div>
                <h2 class="text-2xl font-bold flex items-center gap-2">
                    <i class="fa-solid fa-user-doctor text-blue-600"></i>
                    {{ 'modals.smartPrescriptionModal.title' | translate }}
                </h2>
                <div class="text-sm text-gray-500 flex gap-4 mt-1">
                    <span><strong>Patient:</strong> {{ cust.fullName }}</span>
                    <span><strong>ID:</strong> {{ cust.citizenId }}</span>
                    <span><strong>Age:</strong> {{ customerAge }}</span>
                </div>
            </div>
            <button (click)="onClose()" class="text-gray-400 hover:text-gray-600 transition-colors" title="Close modal">
                <i class="fa-solid fa-times text-xl"></i>
            </button>
        </div>

        <!-- ⚠️ QUOTA WARNING BANNER (Restored) -->
        @if(activePrescriptionWarning()) {
          <div class="mb-4 bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r-md text-sm animate-fade-in flex-shrink-0 shadow-sm">
             <div class="flex items-start gap-3">
                <i class="fa-solid fa-triangle-exclamation text-amber-600 mt-0.5 text-lg"></i>
                <div>
                   <p class="font-bold text-amber-900">ตรวจพบใบสั่งยาเดิมที่ยังไม่หมดอายุ (Active Quota Found)</p>
                   <p class="text-amber-800 mt-1 font-medium">{{ activePrescriptionWarning() }}</p>
                </div>
             </div>
          </div>
        }
        
        <!-- TABS -->
        <div class="flex-shrink-0 mb-4 border-b border-gray-200">
            <nav class="-mb-px flex space-x-8">
                <button (click)="activeTab.set('current')" [class]="'whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm transition-all ' + (activeTab() === 'current' ? 'border-blue-500 text-blue-600 font-bold' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300')">
                    <i class="fa-solid fa-pen-to-square mr-2"></i> สั่งจ่ายยา (Current Order)
                </button>
                <button (click)="activeTab.set('history')" [class]="'whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm transition-all ' + (activeTab() === 'history' ? 'border-blue-500 text-blue-600 font-bold' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300')">
                    <i class="fa-solid fa-clock-rotate-left mr-2"></i> ประวัติการรักษา (History)
                </button>
            </nav>
        </div>

        <!-- CONTENT AREA -->
        <div class="flex-grow overflow-y-auto pr-2 -mr-2">
            
            @if(activeTab() === 'current') {
                @if(hasVitals()) {
                    <div class="mb-6 p-4 bg-slate-50 border border-slate-200 rounded-xl">
                        <h3 class="text-sm font-bold text-slate-700 mb-3 flex items-center gap-2"><i class="fa-solid fa-heart-pulse text-red-500"></i> สัญญาณชีพ (Vitals)</h3>
                        <div class="grid grid-cols-3 md:grid-cols-6 gap-4 text-center">
                            <div><dt class="text-xs text-slate-500">Temp.</dt><dd class="font-bold text-lg">{{ prescription()?.temperature_c | number:'1.1-1' }} °C</dd></div>
                            <div><dt class="text-xs text-slate-500">Pulse</dt><dd class="font-bold text-lg">{{ prescription()?.pulse_rate }} <span class="text-xs">bpm</span></dd></div>
                            <div><dt class="text-xs text-slate-500">Resp.</dt><dd class="font-bold text-lg">{{ prescription()?.respiration_rate }} <span class="text-xs">/min</span></dd></div>
                            <div><dt class="text-xs text-slate-500">BP</dt><dd class="font-bold text-lg">{{ prescription()?.blood_pressure || '-' }}</dd></div>
                            <div><dt class="text-xs text-slate-500">Weight</dt><dd class="font-bold text-lg">{{ prescription()?.weight_kg | number:'1.1-1' }} <span class="text-xs">kg</span></dd></div>
                            <div><dt class="text-xs text-slate-500">Height</dt><dd class="font-bold text-lg">{{ prescription()?.height_cm }} <span class="text-xs">cm</span></dd></div>
                        </div>
                    </div>
                }

                <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    <div class="space-y-6">
                        @if(isDoctor()) {
                            <div class="bg-emerald-50 p-5 rounded-lg border border-emerald-100 relative overflow-hidden">
                                <div class="absolute top-0 right-0 p-2 opacity-10 pointer-events-none">
                                    <i class="fa-solid fa-wand-magic-sparkles text-6xl text-emerald-600"></i>
                                </div>
                                
                                <h3 class="font-bold text-emerald-800 mb-2 flex items-center gap-2">
                                    <i class="fa-solid fa-wand-magic-sparkles"></i> {{ 'modals.smartPrescriptionModal.aiAssistant' | translate }}
                                </h3>
                                <p class="text-xs text-emerald-600 mb-3">{{ 'modals.smartPrescriptionModal.aiDescription' | translate }}</p>
                                
                                <textarea 
                                    [(ngModel)]="aiPrompt" 
                                    rows="4" 
                                    class="w-full text-sm border-emerald-200 rounded-md p-3 focus:ring-emerald-500 focus:border-emerald-500 bg-white shadow-inner"
                                    [placeholder]="'modals.smartPrescriptionModal.aiPlaceholder' | translate"></textarea>
                                
                                <button 
                                    (click)="generateWithAi()" 
                                    [disabled]="isGenerating() || !geminiService.isConfigured()"
                                    class="mt-3 w-full bg-emerald-600 text-white py-2 rounded-md hover:bg-emerald-700 transition-all font-bold text-sm flex items-center justify-center gap-2 disabled:bg-gray-400 disabled:cursor-not-allowed shadow-md">
                                    @if(isGenerating()) {
                                        <i class="fa-solid fa-spinner animate-spin"></i> {{ 'modals.smartPrescriptionModal.aiGeneratingButton' | translate }}
                                    } @else {
                                        <i class="fa-solid fa-bolt"></i> {{ 'modals.smartPrescriptionModal.aiGenerateButton' | translate }}
                                    }
                                </button>
                            </div>
                        }
                    </div>

                    <div class="space-y-4">
                        <div class="bg-blue-50 p-4 rounded-t-lg border-b border-blue-100">
                            <h3 class="font-bold text-blue-900">{{ 'modals.smartPrescriptionModal.prescriptionDetails' | translate }}</h3>
                        </div>
                        
                        <form [formGroup]="prescriptionForm" class="space-y-4 px-2">
                            <div>
                                <label class="block text-xs font-bold text-gray-500 uppercase mb-1">{{ 'modals.smartPrescriptionModal.symptomsLabel' | translate }}</label>
                                <input type="text" formControlName="symptoms" class="w-full border-gray-300 rounded-md p-2 text-sm focus:ring-blue-500 focus:border-blue-500 shadow-sm disabled:bg-gray-100">
                            </div>
                            
                            <div class="grid grid-cols-2 gap-4 bg-slate-50 p-3 rounded-lg border border-slate-200">
                                <div>
                                    <label class="block text-xs font-bold text-gray-500 uppercase mb-1">{{ 'modals.smartPrescriptionModal.dosageLabel' | translate }}</label>
                                    <input type="number" formControlName="dosagePerDay" class="w-full border-gray-300 rounded-md p-2 text-sm text-center font-bold text-blue-700">
                                </div>
                                <div>
                                    <label class="block text-xs font-bold text-gray-500 uppercase mb-1">{{ 'modals.smartPrescriptionModal.unitLabel' | translate }}</label>
                                    <select formControlName="dosageUnit" class="w-full border-gray-300 rounded-md p-2 text-sm bg-white">
                                        <option value="GRAM">{{ 'modals.smartPrescriptionModal.unitGram' | translate }}</option>
                                        <option value="PIECE">{{ 'modals.smartPrescriptionModal.unitPiece' | translate }}</option>
                                    </select>
                                </div>
                                <div>
                                    <label class="block text-xs font-bold text-gray-500 uppercase mb-1">{{ 'modals.smartPrescriptionModal.durationLabel' | translate }}</label>
                                    <input type="number" formControlName="durationDays" class="w-full border-gray-300 rounded-md p-2 text-sm text-center">
                                </div>
                                <div>
                                    <label class="block text-xs font-bold text-gray-500 uppercase mb-1">{{ 'modals.smartPrescriptionModal.totalLabel' | translate }}</label>
                                    <input type="number" formControlName="totalAmount" class="w-full border-gray-300 rounded-md p-2 text-sm text-center bg-gray-100 font-bold" readonly>
                                </div>
                            </div>

                            <div>
                                <label class="block text-xs font-bold text-gray-500 uppercase mb-1">{{ 'modals.smartPrescriptionModal.usageInstructionsLabel' | translate }}</label>
                                <textarea formControlName="usageInstructions" rows="3" class="w-full border-gray-300 rounded-md p-2 text-sm focus:ring-blue-500 focus:border-blue-500 shadow-sm"></textarea>
                            </div>
                        </form>
                    </div>
                </div>
            } @else {
                <div class="h-full">
                    @if(isLoadingHistory()) {
                        <div class="text-center py-20 text-slate-500"><i class="fa-solid fa-spinner animate-spin text-3xl mb-4"></i><p>Loading History...</p></div>
                    } @else {
                        <div class="overflow-hidden rounded-lg border border-slate-200 shadow-sm">
                            <table class="min-w-full divide-y divide-slate-200">
                                <thead class="bg-slate-50">
                                    <tr>
                                        <th class="px-4 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">Date</th>
                                        <th class="px-4 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">Doctor</th>
                                        <th class="px-4 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">Diagnosis</th>
                                        <th class="px-4 py-3 text-right text-xs font-bold text-slate-500 uppercase tracking-wider">Prescribed</th>
                                    </tr>
                                </thead>
                                <tbody class="bg-white divide-y divide-slate-200">
                                    @for(h of patientHistory(); track h.id) {
                                        <tr class="hover:bg-slate-50 transition-colors">
                                            <td class="px-4 py-3 text-sm text-slate-700 whitespace-nowrap">{{ h.createdAt | date:'d MMM yyyy' }}</td>
                                            <td class="px-4 py-3 text-sm text-slate-700 whitespace-nowrap font-medium">{{ h.doctorName || 'N/A' }}</td>
                                            <td class="px-4 py-3 text-sm text-slate-700">
                                                <span class="bg-yellow-50 text-yellow-800 px-2 py-1 rounded text-xs border border-yellow-200">{{ h.approvedItems?.symptoms || 'N/A' }}</span>
                                            </td>
                                            <td class="px-4 py-3 text-sm text-right font-bold text-slate-900">
                                                {{ h.approvedItems?.totalAmount }} {{ h.approvedItems?.dosageUnit }}
                                            </td>
                                        </tr>
                                    } @empty {
                                        <tr><td colspan="4" class="text-center py-10 text-slate-400">No previous history found.</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    }
                </div>
            }
        </div>

        @if(activeTab() === 'current') {
            <div class="flex-shrink-0 mt-6 pt-4 border-t bg-gray-50 -mx-6 -mb-6 p-4 rounded-b-lg">
                @if (errorMessage()) {
                  <div class="mb-4 bg-rose-50 border-l-4 border-rose-500 text-rose-800 p-4 rounded-r-md text-sm shadow-sm animate-shake" role="alert">
                    <div class="flex items-center justify-between">
                        <div class="flex items-center gap-2">
                             <i class="fa-solid fa-circle-exclamation text-rose-500"></i> 
                             <span class="font-bold">เกิดข้อผิดพลาด: {{ errorMessage() }}</span>
                        </div>
                        @if(errorMessage()?.includes('INSUFFICIENT_FUNDS')) {
                            <a routerLink="/admin/billing" class="px-3 py-1 bg-rose-600 text-white rounded font-bold hover:bg-rose-700 transition-colors">
                                ไปหน้าเติมเงิน
                            </a>
                        }
                    </div>
                  </div>
                }
                <div class="flex justify-end gap-3">
                  @if(isDoctor()) {
                      @if(view() === 'main') {
                          <button (click)="submitReview('REJECTED')" [disabled]="isSubmitting()" class="px-5 py-2.5 bg-rose-100 text-rose-700 hover:bg-rose-200 rounded-lg transition-colors font-bold text-sm">
                              {{ 'modals.smartPrescriptionModal.rejectButton' | translate }}
                          </button>
                          <button (click)="submitReview('APPROVED')" [disabled]="isSubmitting() || prescriptionForm.invalid" class="px-6 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 shadow-md font-bold text-sm flex items-center gap-2 disabled:bg-blue-300">
                              @if(isSubmitting()) { <i class="fa-solid fa-spinner animate-spin"></i> }
                              @else { <i class="fa-solid fa-file-signature"></i> }
                              {{ 'modals.smartPrescriptionModal.approveButton' | translate }}
                          </button>
                      } @else if (view() === 'rejecting') {
                          <div class="flex-grow flex gap-2 items-center">
                              <input type="text" [(ngModel)]="rejectionNotes" placeholder="ระบุเหตุผลการปฏิเสธ..." class="flex-grow border-rose-300 rounded-md p-2 text-sm focus:ring-rose-500 focus:border-rose-500">
                              <button (click)="confirmRejection()" class="px-4 py-2 bg-rose-600 text-white rounded-md hover:bg-rose-700 text-sm font-bold">ยืนยันการปฏิเสธ</button>
                              <button (click)="cancelRejection()" class="px-4 py-2 text-gray-600 hover:text-gray-800 text-sm">ยกเลิก</button>
                          </div>
                      }
                  } @else {
                      <span class="mr-auto self-center text-sm text-slate-500 italic"><i class="fa-solid fa-lock mr-1"></i> View Only Mode</span>
                      <button (click)="onClose()" class="px-6 py-2.5 bg-slate-200 text-slate-700 hover:bg-slate-300 rounded-lg font-bold text-sm transition-colors">
                          Close
                      </button>
                  }
                </div>
            </div>
        }
      }
    </div>
  </div>
}
